module.exports = __webpack_public_path__ + "static/media/Bath3.67b232a5.jpg";